module.exports = __webpack_public_path__ + "static/media/emptyImage.a3f5d0c6.png";